import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getFormatDetails, updateFormat } from "../../helpers/http_formats_requests";
import { useQuery } from "@tanstack/react-query";

export default function FormatUpdate() {
    const navigate = useNavigate();
    const { id } = useParams();

    const { data, isFetching } = useQuery({ 
        queryKey: ['getFormatDetails', id], 
        queryFn: () => getFormatDetails(id), 
        staleTime: 1000 * 5 
    });

    const { data: formatData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Formato - Editar",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        updateFormat(data, () => navigate('/formatos'));
    };

    return <DynamicFormPage 
        isLoading={isFetching} 
        initialData={formatData} 
        title={"Formato - Editar"} 
        formFieldList={formFieldList} 
        onCancel={() => navigate(-1)} 
        onSubmit={handleSubmit} 
    />;
}
